import { createFileRoute } from '@tanstack/react-router';
import { SellerTermsPage } from '../../pages/SellerTermsPage';
import { staticPageHead } from '../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/seller-terms')({
  head: () =>
    staticPageHead({
      path: '/seller-terms',
      title: 'Seller Terms - AnyAPI',
      description:
        'The terms for selling through the AnyAPI marketplace: which answers are paid, your 80% share, verification, payouts, deductions, taxes, and how buyer request data is handled.',
      crumb: 'Seller Terms',
    }),
  component: SellerTermsPage,
});
